'use client';

import { ReactNode } from 'react';
import { APP_ROUTE_PATHS, PUBLIC_ROUTES } from '@/configs/routes';
import { useAdminGuard } from '@/hooks/useAdminGuard';
import { GetStartedCardLink } from './GetStartedCardLink';

type RegistryGetStartedCardLinkProps = {
  ariaDescribedby: string;
  ariaLabelledby: string;
  children: ReactNode;
};

export function RegistryGetStartedCardLink({
  ariaDescribedby,
  ariaLabelledby,
  children,
}: RegistryGetStartedCardLinkProps) {
  const { handleClickLink } = useAdminGuard(APP_ROUTE_PATHS.DASHBOARD);

  return (
    <GetStartedCardLink
      aria-describedby={ariaDescribedby}
      aria-labelledby={ariaLabelledby}
      href={PUBLIC_ROUTES.REGISTRY_LANDING}
      onClick={handleClickLink}
    >
      {children}
    </GetStartedCardLink>
  );
}
